"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var dropdown_svg_1 = __importDefault(require("res/img/dropdown.svg"));
exports.default = (function (props) { return (react_1.default.createElement("div", { className: "input flex flex-row" },
    react_1.default.createElement("label", { htmlFor: "se_" + props.name },
        props.altLabel || lodash_1.default.startCase(props.name.replace(/-/g, " ")),
        ":"),
    react_1.default.createElement("div", { className: "select" },
        react_1.default.createElement("select", { name: props.name, id: "se_" + props.name, onChange: props.onChange, "data-customer": props.dataCustomer, value: props.value },
            react_1.default.createElement("option", { value: "", disabled: true }, "Please Select..."),
            props.options.map(function (option, index) { return (react_1.default.createElement("option", { value: option.value, key: index }, option.text)); })),
        react_1.default.createElement("div", { className: "dropdown flex flex-column flex-center" },
            react_1.default.createElement("img", { src: dropdown_svg_1.default, alt: "Dropdown" }))))); });
